import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_AdvancedSearchComponent = _resolveComponent("AdvancedSearchComponent")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_form, {
      onSubmit: _withModifiers(_ctx.doSearch, ["prevent"]),
      modelValue: _ctx.filtersInputs.validFilters,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtersInputs.validFilters) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "py-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AdvancedSearchComponent, { loading: _ctx.loading }, {
                  "basic-search": _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      id: "coursesFilters-txt-courseName",
                      modelValue: _ctx.filtersInputs.courseName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtersInputs.courseName) = $event)),
                      modelModifiers: { trim: true },
                      rules: _ctx.rules.courseName,
                      label: _ctx.$t('labels.courseName'),
                      variant: "outlined",
                      clearable: ""
                    }, null, 8, ["modelValue", "rules", "label"])
                  ]),
                  "advanced-search": _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          id: "coursesFilters-txt-studyPlan",
                          modelValue: _ctx.filtersInputs.stdPlan,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersInputs.stdPlan) = $event)),
                          modelModifiers: { trim: true },
                          rules: _ctx.rules.stdPlan,
                          label: _ctx.$t('labels.studyPlan'),
                          variant: "outlined",
                          clearable: ""
                        }, null, 8, ["modelValue", "rules", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          id: "coursesFilters-txt-IHId",
                          modelValue: _ctx.filtersInputs.IHId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtersInputs.IHId) = $event)),
                          modelModifiers: { trim: true },
                          rules: _ctx.rules.IHId,
                          label: _ctx.$t('labels.IHId'),
                          variant: "outlined",
                          clearable: ""
                        }, null, 8, ["modelValue", "rules", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          id: "coursesFilters-select-courseType",
                          items: _ctx.filters.courseTypes,
                          "item-title": "baName",
                          "item-value": "baID",
                          loading: _ctx.loading,
                          disabled: _ctx.loading,
                          "model-value": _ctx.filtersInputs.courseType || null,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filtersInputs.courseType = $event)),
                          label: _ctx.$t('labels.courseType'),
                          variant: "outlined"
                        }, null, 8, ["items", "loading", "disabled", "model-value", "label"])
                      ]),
                      _: 1
                    }),
                    (_ctx.filters.activeStatus)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              id: "coursesFilters-select-activeStatus",
                              items: _ctx.filters.activeStatus,
                              "item-value": "id",
                              "item-title": "name",
                              loading: _ctx.loading,
                              disabled: _ctx.loading,
                              "model-value": _ctx.filtersInputs.activeStatus || null,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filtersInputs.activeStatus = $event)),
                              label: _ctx.$t('labels.status'),
                              variant: "outlined"
                            }, null, 8, ["items", "loading", "disabled", "model-value", "label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _cache[6] || (_cache[6] = _createElementVNode("input", {
                  type: "submit",
                  hidden: ""
                }, null, -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit", "modelValue"])
  ]))
}